import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Circular from "../Circular/Circular";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import { updateSlot } from "../../services/slots/slots";
import { createEvent } from "../../services/events/events";

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class EditSlot extends Component {
  constructor(props) {
    super(props);
    this.updateSlot = this.updateSlot.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      sizes: [
        {
          value: "small",
          label: "Pequeno",
        },
        {
          value: "medium",
          label: "Médio",
        },
        {
          value: "large",
          label: "Grande",
        },
        {
          value: "extra-large",
          label: "Extra Grande",
        },
      ],
      statuses: [
        {
          value: "available",
          label: "Disponível",
          enabled: true,
          exception: "unavailable"
        },
        {
          value: "reserved",
          label: "Reservado",
          enabled: false,
          exception: false
        },
        {
          value: "allocated",
          label: "Alocado pelo agente",
          enabled: false,
          exception: false
        },
        {
          value: "allocatedClient",
          label: "Alocado pelo cliente",
          enabled: false,
          exception: false
        },
        {
          value: "unavailable",
          label: "Bloqueadas",
          enabled: true,
          exception: "available"
        },
        {
          value: "to_be_free",
          label: "Necessita Reparo",
          enabled: true,
          exception: true
        },
        {
          value: "dirty",
          label: "Necessita Limpeza",
          enabled: true,
          exception: true
        },
      ],
      categories: [
        {
          value: false,
          label: "sem restrição",
        },
        {
          value: true,
          label: "deficiente físico",
        },
        {
          value: "control",
          label: "painel de controle",
        }
      ],

      size: this.props.slot.size,

      status: this.props.slot.status,
      slotName: this.props.slot.slotName,
      label: this.props.slot.label,
      deviceCondition: this.props.slot.deviceCondition,
      id: this.props.slot.id,
      pne: this.props.slot.pne,
      slot: {},
      waiting: false,
      error: false,
      category: "",
      currentUser: JSON.parse(localStorage.getItem("user")).data
    };
  }

  updateSlot = (slot) => {
    updateSlot(slot, (data) => {
      this.setState({ slot: {}, waiting: false });
      this.props.onChange(false);
      if (data) {
        let d = {
          'lockerId': this.props.lockerId,
          'parametro1': slot.label,
          'code': '103',
          'usuario': this.state.currentUser.name,
          'complemento': `Porta atualizada`
        };

        createEvent(d, () => {
          console.log(`Creted event`);
        });

        this.props.setNotification(
          `Porta foi atualizada com sucesso!`,
          "success"
        );
      } else {
        this.props.setNotification(
          `Falha ao atualizar Porta !`,
          "danger"
        );
      }
    });
  };

  handleChange = (event) => {
    let e = event.target.id ? event.target.id : event.target.name;
    switch (e) {
      case "slot":
        this.setState({ slotName: event.target.value });
        break;
      case "status":
        this.setState({ status: event.target.value });
        break;
      case "label":
        this.setState({ label: event.target.value });
        break;
      case "deviceCondition":
        this.setState({ deviceCondition: event.target.value });
        break;
      case "category":
        if (event.target.value === "control") {
          this.setState({ deviceCondition: event.target.value });
        } else {
          this.setState({ pne: event.target.value });
        }
        break;

      default:
        this.setState({ size: event.target.value });
        break;
    }
  };

  handleClickOpen = () => {
    this.props.onChange(true);
  };

  handleCreate = () => {
    let {
      slotName,
      status,
      size,
      deviceCondition,
      slot,
      label,
      category,
      id,
      pne
    } = this.state;
    let { lockerId } = this.props;

    if (lockerId && size && slotName && status && deviceCondition && label) {
      Object.assign(slot, {
        lockerId,
        size,
        slotName,
        status,
        deviceCondition,
        id,
        label,
        pne
      });
      this.setState({ slot, waiting: true, error: false });
      this.updateSlot(slot);
    } else {
      this.setState({ error: true });
    }
  };

  handleClose = () => {
    this.props.onChange(false);
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          className={this.state.waiting ? classes.dialog : null}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.state.waiting ? "Atualizando Porta" : "Atualizar Porta"}
          </DialogTitle>
          <DialogContent>
            {this.state.waiting ? (
              <div>
                <Circular />
              </div>
            ) : (
                <form className={classes.root} noValidate autoComplete="off">
                  <div className="align-fields">
                    <FormControl
                      className={
                        this.state.error && !this.state.slotName
                          ? classes.red
                          : classes.green
                      }
                    >
                      <InputLabel htmlFor="slot">Porta</InputLabel>
                      <Input
                        error={
                          this.state.error && !this.state.slotName ? true : false
                        }
                        value={this.state.slotName}
                        onChange={this.handleChange}
                        id="slot"
                      />
                    </FormControl>
                    <TextField
                      className={
                        this.state.error && !this.state.status
                          ? classes.red
                          : classes.green
                      }
                      error={
                        this.state.error && !this.state.status ? true : false
                      }
                      select
                      label="Status"
                      name="status"
                      value={this.state.status}
                      onChange={this.handleChange}
                    >
                      {this.state.statuses.map((option) => (
                        <MenuItem disabled={!option.exception ? true : ((option.exception === this.state.status || option.exception === true || ((this.state.status === 'to_be_free' || this.state.status === 'dirty') && (option.value === 'unavailable' || option.value === 'available'))) ? false : true)} key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      className={
                        this.state.error && !this.state.size
                          ? classes.red
                          : classes.green
                      }
                      name="size"
                      error={this.state.error && !this.state.size ? true : false}
                      select
                      label="Tamanho"
                      value={this.state.size}
                      onChange={this.handleChange}
                    >
                      {this.state.sizes.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <FormControl
                      className={
                        this.state.error && !this.state.deviceCondition
                          ? classes.red
                          : classes.green
                      }
                    >
                      <InputLabel htmlFor="deviceCondition">
                        Condições do dispositivo
                    </InputLabel>
                      <Input
                        error={
                          this.state.error && !this.state.deviceCondition
                            ? true
                            : false
                        }
                        value={this.state.deviceCondition}
                        onChange={this.handleChange}
                        id="deviceCondition"
                      />
                    </FormControl>
                    <FormControl
                      className={
                        this.state.error && !this.state.label
                          ? classes.red
                          : classes.green
                      }
                    >
                      <InputLabel htmlFor="label">Label</InputLabel>
                      <Input
                        error={
                          this.state.error && !this.state.label ? true : false
                        }
                        value={this.state.label}
                        onChange={this.handleChange}
                        id="label"
                      />
                    </FormControl>
                    <TextField
                      className={
                        this.state.error && !this.state.categories
                          ? classes.red
                          : classes.green
                      }
                      id="outlined-size-input"
                      error={
                        this.state.error && !this.state.categories ? true : false
                      }
                      select
                      name="category"
                      label="Categoria"
                      value={(this.state.deviceCondition === 'control') ? 'control' : this.state.pne}
                      onChange={this.handleChange}
                    >
                      {this.state.categories.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>

                  </div>
                </form>
              )}
          </DialogContent>
          <DialogActions>
            {this.state.waiting ? null : (
              <div>
                <Button onClick={this.handleClose} color="default">
                  Cancelar
                </Button>
                <Button onClick={this.handleCreate} color="primary" autoFocus>
                  Atualizar
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(useStyles)(EditSlot);
